import { useTrendingItems } from 'react-instantsearch';

import HorizontalScroller from '@javascript/components/application/horizontalScroller';
import InstantSearchVehicle from './instantSearchVehicle';

import type { InstantSearchResult } from '@javascript/types/InstantSearch';
import Analytics from '@javascript/lib/analytics';

const InstantSearchTrendingVehicles = () => {
  const { items: trendingVehicles, sendEvent } =
    useTrendingItems<InstantSearchResult>({
      queryParameters: { filters: 'isReserved:false' },
    });

  if (trendingVehicles.length === 0) return null;

  const googleAnalytics = (position: number) => {
    Analytics.trackEvent('interaction', {
      action: `item at position ${position} clicked`,
      label: 'trending_items_carousel',
    });
  };
  return (
    <section className="ch-mt--7 ch-mb--4">
      <h4 className="ac-instant-search__trending ch-fs--5 ch-display--flex ch-align-items--center ch-justify-content--center">
        Trending
      </h4>
      <div className="ac-vehicle-gallery">
        <HorizontalScroller>
          {trendingVehicles.map((hit, index) => (
            <InstantSearchVehicle
              analytics={() => googleAnalytics(index)}
              hideImageSlider
              hit={hit}
              key={hit.objectID}
              sendEvent={sendEvent}
            />
          ))}
        </HorizontalScroller>
      </div>
    </section>
  );
};
export default InstantSearchTrendingVehicles;
